var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "verified",
    clipPath: "url(#clip0_4908_1655)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M71.6984 12.3014C63.7657 4.36882 53.2186 0 42 0C30.7812 0 20.234 4.36882 12.3014 12.3014C4.36866 20.2342 0 30.7814 0 42C0 53.2186 4.36866 63.7657 12.3014 71.6984C20.2342 79.6312 30.7812 84 42 84C53.2186 84 63.7657 79.6312 71.6984 71.6984C79.6312 63.7657 84 53.2186 84 42C84 30.7814 79.6312 20.2343 71.6984 12.3014ZM42 79.0781C21.555 79.0781 4.92188 62.445 4.92188 42C4.92188 21.555 21.555 4.92188 42 4.92188C62.445 4.92188 79.0781 21.555 79.0781 42C79.0781 62.445 62.445 79.0781 42 79.0781Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M62.0657 28.5236C61.1047 27.5629 59.5465 27.5629 58.5856 28.5238L36.854 50.2553L25.4144 38.8158C24.4535 37.8549 22.8953 37.8549 21.9342 38.8158C20.9731 39.7767 20.9731 41.3349 21.9342 42.296L35.1138 55.4756C35.5944 55.9562 36.2242 56.1964 36.8539 56.1964C37.4835 56.1964 38.1135 55.956 38.5939 55.4756L62.0657 32.0039C63.0267 31.043 63.0267 29.4847 62.0657 28.5236Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4908_1655"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 84,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.56a2a6bc568defeccff89a1aa5440543.svg";
export { ForwardRef as ReactComponent };